import {
  DEDUCTWALLET,
  CLEAR_HR_REWARDMASTER,
  GETHRREWARDWALLETPASSBOOK,
  GETHRREWARDWALLETWALLET,
  CREATEHRREWARDWALLETPASSBOOK,
  UPDATEHRREWARDWALLETPASSBOOK,
  DELETEHRREWARDWALLETPASSBOOK,

  GETHRREWARDMASTER,
  CREATEHRREWARDMASTER,
  UPDATEHRREWARDMASTER,
  DELETEHRREWARDMASTER,

  CREATEACCOUNTBANKMASTER,
  GETACCOUNTBANKMASTER,
  UPDATEACCOUNTBANKMASTER,
  DELETEACCOUNTBANKMASTER,

  CREATEACCOUNTLEDGERMASTER,
  GETACCOUNTLEDGERMASTER,
  UPDATEACCOUNTLEDGERMASTER,
  DELETEACCOUNTLEDGERMASTER,
  CREATEHOSPITALEEXPENSE,
  CREATEHOSPITALEINCOME,
  DELETEHOSPITALEEXPENSE,
  DELETEHOSPITALEINCOME,
  GETHOSPITALEEXPENSE,
  GETHOSPITALEINCOME,
  UPDATEHOSPITALEEXPENSE,
  UPDATEHOSPITALEINCOME,
  GETACCOUNTLEDGERBYID,
  axios,
  baseURL,
} from "./types";

export const createHospitaleincome = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitaleincome/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEHOSPITALEINCOME,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getHospitaleincome = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitaleincome/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETHOSPITALEINCOME,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const updateHospitaleincome = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuphospitaleincome/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEHOSPITALEINCOME,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteHospitaleincome = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuphospitaleincome/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEHOSPITALEINCOME,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};


export const createHospitaleexpense = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitaleexpense/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: CREATEHOSPITALEEXPENSE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const getHospitaleexpense = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post",
    url: baseURL + "/api/setuphospitaleexpense/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: GETHOSPITALEEXPENSE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};
export const updateHospitaleexpense = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setuphospitaleexpense/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATEHOSPITALEEXPENSE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};

export const deleteHospitaleexpense = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setuphospitaleexpense/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  axios(config)
    .then(function (response) {
      dispatch({
        type: DELETEHOSPITALEEXPENSE,
        payload: response.data,
      });
    })
    .catch(function (error) {
      console.log(error);
    });
};


export const getAccountMainBankMaster = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/Bank/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETACCOUNTBANKMASTER, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createAccountMainBankMaster = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/Bank/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEACCOUNTBANKMASTER, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateAccountMainBankMaster = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/Bank/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEACCOUNTBANKMASTER, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteAccountMainBankMaster = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/Bank/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: DELETEACCOUNTBANKMASTER, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const getAccountMainLedgerMaster = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/Ledger/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETACCOUNTLEDGERMASTER, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createAccountMainLedgerMaster = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/Ledger/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEACCOUNTLEDGERMASTER, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const updateAccountMainLedgerMaster = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/Ledger/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEACCOUNTLEDGERMASTER, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteAccountMainLedgerMaster = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/Ledger/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) {
    dispatch({ type: DELETEACCOUNTLEDGERMASTER, payload: response.data, });
    return response.data;
  }).catch(function (error) {
    console.log(error);
    throw error;
  });
};


export const getAccountLedgerbyid = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/Ledger/byid",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETACCOUNTLEDGERBYID, payload: response.data, }); }).catch(function (error) { console.log(error); });
};

export const getAccountHRWalletData = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/hospitalwallet/my-wallet",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) {
    dispatch({ type: GETHRREWARDWALLETWALLET, payload: response.data, });
    return response.data;
  }).catch(function (error) { console.log(error); });
};
export const getAccountHRWalletPassbook = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/hospitalwallet/my-passbook",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) {
    dispatch({ type: GETHRREWARDWALLETPASSBOOK, payload: response.data, });
    return response.data;
  }).catch(function (error) { console.log(error); });
};
export const awardWalletPoints = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/hospitalwallet/award",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: CREATEHRREWARDWALLETPASSBOOK, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const redeemWalletPoints = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/hospitalwallet/redeem",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRREWARDWALLETPASSBOOK, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteAccountHRWalletPassbook = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/hospitalwallet/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) {
    dispatch({ type: DELETEHRREWARDWALLETPASSBOOK, payload: response.data, });
    return response.data;
  }).catch(function (error) { console.log(error); throw error; });
};

export const getAccountHRRewardMaster = (data) => (dispatch) => {
  console.log(data)
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalrewardmaster/getall",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) { dispatch({ type: GETHRREWARDMASTER, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const createAccountHRRewardMaster = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/setuphospitalrewardmaster/create",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) {
    dispatch({ type: CREATEHRREWARDMASTER, payload: response.data, });
    return response.data;
  }).catch(function (error) { console.log(error); });
};
export const updateAccountHRRewardMaster = (data) => (dispatch) => {
  var config = {
    method: "patch", url: baseURL + "/api/setuphospitalrewardmaster/update",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  axios(config).then(function (response) { dispatch({ type: UPDATEHRREWARDMASTER, payload: response.data, }); }).catch(function (error) { console.log(error); });
};
export const deleteAccountHRRewardMaster = (data) => (dispatch) => {
  var config = {
    method: "delete", url: baseURL + "/api/setuphospitalrewardmaster/delete",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) {
    dispatch({ type: DELETEHRREWARDMASTER, payload: response.data, });
    return response.data;
  }).catch(function (error) { console.log(error); throw error; });
};

export const deductWalletPoints = (data) => (dispatch) => {
  var config = {
    method: "post", url: baseURL + "/api/hospitalwallet/deduct",
    headers: { Authorization: `Bearer ${localStorage.getItem("token")}`, "Content-Type": "application/json", }, data: data,
  };
  return axios(config).then(function (response) {
    dispatch({ type: DEDUCTWALLET, payload: response.data, });
    return response.data;
  }).catch(function (error) { console.log(error); throw error; });
};

export const clearHrRewardMaster = () => ({ type: CLEAR_HR_REWARDMASTER, });
